import './lib/Logger'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { bootstrap } from './Bootstrap'
import { App } from './components/App'
import * as serviceWorker from './serviceWorker'

const root = document.getElementById('root') as HTMLElement

// Log build version info using CRA env variables
// Values are injected at build time via REACT_APP_* envs in Dockerfile/CI.
const commitSha = process.env.REACT_APP_COMMIT_SHA ?? 'local-version'
const buildDate = process.env.REACT_APP_BUILD_DATE ?? new Date()

// e.g. "Commit: local-version", "Build Date: 2026-01-27T11:02:43Z"
// eslint-disable-next-line no-console
console.log(`Commit: ${commitSha}`)
// eslint-disable-next-line no-console
console.log(`Build Date: ${buildDate}`)

bootstrap
  .init()
  .then(() => {
    const container = document.getElementById('root')
    const root = createRoot(container!)
    root.render(<App />)
  })
  .catch(window.logger.error)

serviceWorker.unregister()
